import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import get from 'lodash/get';
import forEach from 'lodash/forEach';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons/faFileDownload';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import FieldFileSlide from './FieldFileSlide.jsx';
import FileClick from './FileClick.jsx';
import FileDrop from './FileDrop.jsx';

function downloadFile(filePath) {
  const link = document.createElement('a');
  link.href = filePath;
  link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
  link.click();
}

const FieldFileSlider = (props) => {
  const {
    api,
    name,
    className = '',
    gridClassName = 'col-6 my-3',
    slideClassName = 'file-slide-cover ratio-ultrawide',
    fileOpts,
  } = props;
  const fOpts = { accept: 'image/jpeg, image/png', ...fileOpts };
  const ctx = useFormikContext();
  const values = get(ctx.values, name, []);

  return (
    <div
      className={`file-slider ${className}`}
    >
      <FieldArray name={name}>
        {({ unshift, move, remove }) => {
          const onFileAdd = (fs) => {
            forEach(fs, (f) => {
              unshift(f);
            });
          };

          return (
            <>
              <FileDrop
                onDrop={onFileAdd}
                className="position-relative"
                {...fOpts}
              >
                <FileClick
                  onFile={onFileAdd}
                  className="position-relative p-4"
                  {...fOpts}
                >
                  <div
                    className="border-primary border-dashed"
                    style={{ height: '150px' }}
                  >
                    <div className="pos-abs-center text-primary">
                      Drop your image or <u>Browse</u>
                    </div>
                  </div>
                </FileClick>
              </FileDrop>
              <div className="container-fluid">
                <div className="row">
                  {values.map((f, i) => (
                    <div
                      className={gridClassName}
                      key={
                        f instanceof File
                          ? `${f.name}>${f.lastModified}`
                          : f
                        }
                    >
                      <FieldFileSlide
                        api={{ url: api }}
                        name={`${name}.${i}`}
                        className={slideClassName}
                      >
                        <div className="ctrls">
                          <button
                            type="button"
                            className="btn btn-link mx-1"
                            onClick={() => downloadFile(f)}
                          >
                            <FA icon={faFileDownload} />
                          </button>
                          <button
                            type="button"
                            className="btn btn-link mx-1"
                            onClick={() => move(i, i - 1)}
                            disabled={i === 0}
                          ><FA icon={faArrowUp} /></button>
                          <button
                            type="button"
                            className="btn btn-link mx-1"
                            onClick={() => move(i, i + 1)}
                            disabled={i === values.length - 1}
                          ><FA icon={faArrowDown} /></button>
                          <button
                            type="button"
                            className="btn btn-link mx-1"
                            onClick={() => remove(i)}
                          ><FA icon={faTimes} /></button>
                        </div>
                      </FieldFileSlide>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default FieldFileSlider;
